<template>
  <div class="faq-holder">
    <div class="heading-arrow" @click="openClose">
      <slot name="heading" />
      <IconExpand class="arrow" :class="{ rotate: openSection }" />
    </div>
    <div class="content" :class="[{ open: openSection }, 'col-11 md-12']">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import IconExpand from '../../../../assets/svg/icon-faq-expand.svg?vue-component';

export default {
  components: {
    IconExpand,
  },
  data() {
    return {
      openSection: false,
    };
  },
  methods: {
    openClose() {
      this.openSection = !this.openSection;
      if (this.openSection) {
        this.renderMathJax();
      }
    },
    renderMathJax() {
      if (window.MathJax) {
        window.MathJax.Hub.Config({
          tex2jax: {
            inlineMath: [['$', '$'], ['\\(', '\\)']],
            processEscapes: true,
          },
          'HTML-CSS': {
            linebreaks: { automatic: true, width: 'container' },
          },
          SVG: {
            linebreaks: { width: '10000px' },
          },
          jax: ['input/TeX', 'output/SVG'],
        });
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-holder {
  .heading-arrow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin-bottom: var(--spacing-16);

    span {
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
      margin: 0;
    }

    .arrow {
      flex-shrink: 0;
      transition: all 250ms ease-in-out;

      &.rotate {
        transform: rotateZ(90deg);
      }
    }
  }

  .content {
    overflow: hidden;
    max-height: 0;
    transition: all 500ms cubic-bezier(0, 1, 0, 1);
    padding-right: 15px;
    color: var(--main-dark-light-3);

    &.open {
      max-height: 9999px;
      transition: max-height 1s ease-in-out;

      &:not(.last) {
        margin-bottom: var(--spacing-24);
      }
    }

    .image-headings {
      font-weight: 600;
      font-size: 22px;
      margin: var(--spacing-40) 0 0;
      text-align: center;
      color: var(--accent-shade-3);

      & ~ * {
        margin-top: 0;
      }

      &.additional {
        margin: var(--spacing-20) 0 var(--spacing-24);
      }
    }

    p {
      line-height: 150%;
      margin: 0;

      + :not(img) {
        margin: var(--spacing-20) 0 0;
      }

      &:first-child {
        margin: 0;
      }
    }

    ul {
      line-height: 150%;
      list-style-type: disc;
      list-style-position: outside;
      margin: 0;
      padding: 0 0 0 var(--spacing-28);

      + p {
        margin: var(--spacing-20) 0 0;
      }
    }

    ol {
      line-height: 150%;
      list-style-position: outside;
      margin: 0;
      padding: 0 0 0 var(--spacing-28);

      + p {
        margin: var(--spacing-20) 0 0;
      }
    }

    img {
      max-width: 100%;
      margin: var(--spacing-16) 0;

      &.no-top-margin {
        margin: 0 0 var(--spacing-16);
      }
    }

    .formulas-overflow {
      overflow: auto;
      scrollbar-color: (var(--main-light-shade-3) var(--main-light));
      scrollbar-width: thin;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: var(--main-light-shade-3);
        border-radius: 10px;
      }

      ::v-deep .mjx-block {
        display: inline-block;
      }
    }

    .inline-formulas {
      ::v-deep .MathJax_SVG_Display {
        display: unset !important;
      }
    }

    a {
      font-weight: 600;
      text-decoration: underline;
      display: inline-block;
    }

    .bolded-text {
      font-weight: 600;
    }
  }
}

@include bp($bp-laptop) {
  .faq-holder {
    .content {
      padding: 0;
    }
  }
}

@include bp($bp-mobile) {
  .faq-holder {
    .heading-arrow {
      span {
        font-size: 18px;
      }
    }

    .content {
      padding: 0;
      color: var(--main-dark);

      .image-headings {
        font-size: 18px;
      }

      img {
        display: block;
        margin: var(--spacing-12) auto;

        &.no-top-margin {
          margin: 0 auto var(--spacing-12);
        }
      }

      .formulas-overflow {
        font-size: 14px;
      }
    }
  }
}
</style>
